import { useEffect, useState } from 'react';
import useApiRequest from './useApiRequest';
import useFacility from './useFacility';
import { GET_OLD_CONF_FACILITY } from '../../app/api/apiRoutes';
import { ConfigurationOLD } from '../../app/models/Configuration_OLD';

export default function useCountHtmlTagCharacters() {
  const { get } = useApiRequest();
  const facilityIds = useFacility();
  const [config, setConfig] = useState<ConfigurationOLD>();
  

  useEffect(() => {

  }, [facilityIds]); 

  const getOldConfig = async () => {
    const ids = `0,${facilityIds}`
    const { result, isError } = await get(GET_OLD_CONF_FACILITY(ids));
    if (!isError) {
      setConfig(result);
    }
  }; 

  
  const countHtmlTagCharacters = (input: string): number => {
    // Wyrażenie regularne do znalezienia wszystkich znaczników HTML
    const regex = /<[^>]*>/g;
    // Znajdowanie wszystkich dopasowań znaczników HTML
    const inputSmall = input.slice(0, 260)
    const matches = inputSmall.match(regex);
    // Jeśli brak dopasowań, zwróć 0
    if (!matches) {
        return 0;
    }
    // Zsumowanie długości wszystkich dopasowanych znaczników HTML
    const totalLength = matches.reduce((sum, tag) => sum + tag.length, 0);
    return totalLength;
}


  return{
    countHtmlTagCharacters,
    config,
  }

}

